export default __webpack_public_path__ + "static/media/offer-placeholder.62c57336.jpg";